import React, { useState } from 'react';
import {
  TitleContainer,
  ModalTitle,
  ModalButtonsContainer,
  Column,
  ModalSubtitle,
  ButtonModalSubscribe,
  StyledInput,
  Gap,
} from './SubscriptionModalComponent.styles';
import { Waveform } from '@uiball/loaders';

import Modal from './Modal';
import { XIcon } from './ModalComponent.styles';

const PromoCodeModal = ({ modalOpen, onClose, loading, width, height, closeDisabled, subscribeWithPromoCode }) => {
  const [code, setCode] = useState('');

  const handleSubscribeWithPromoCode = () => {
    subscribeWithPromoCode(code);
    setCode('');
  };

  return (
    <Modal
      isOpen={modalOpen}
      width={width}
      height={height}
      onClose={() => {
        !closeDisabled && onClose();
      }}
      fade>
      <div style={{}}>
        <TitleContainer>
          <ModalTitle>{'Welcome to the Ring Leader Era! '}</ModalTitle>
          <XIcon onClick={onClose} />
        </TitleContainer>
        <ModalSubtitle>
          To ensure your listing remains visible in our app and for our couples to contact you, please subscribe now.
        </ModalSubtitle>
        <Gap />
        <StyledInput placeholder="Enter Promo Code" value={code} onChange={n => setCode(n.target.value)} />
        <Gap />
        <ModalSubtitle>Thank you for choosing Ring Leader!</ModalSubtitle>
      </div>
      <ModalButtonsContainer>
        {!loading ? (
          <ButtonModalSubscribe
            title={'Subscribe'}
            disabled={!code}
            //containerStyle={{ width: '160px' }}
            onClick={() => {
              code && handleSubscribeWithPromoCode();
            }}>
            Subscribe
          </ButtonModalSubscribe>
        ) : (
          <Waveform size={26} lineWeight={3.5} speed={1} color="black" />
        )}
      </ModalButtonsContainer>
    </Modal>
  );
};

export default PromoCodeModal;
